var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCA4739B-0DD3-4EFB-B430-A2A90F1C96B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 6.5,
    cy: 6.5,
    r: 6.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-40.000000, -1036.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/info-blue",
    transform: "translate(40.500000, 1036.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    opacity: 0.797935268,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/dark-blue",
    mask: "url(#mask-2)",
    fill: "#48A0E0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.500000, -0.500000)",
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.64,3.15828179 C7.64,3.42082605 7.54263557,3.64507925 7.34790378,3.83104811 C7.15317199,4.01701697 6.91835189,4.11 6.64343643,4.11 C6.37310289,4.11 6.13828278,4.01482913 5.93896907,3.82448454 C5.73965536,3.63413994 5.64,3.41207458 5.64,3.15828179 C5.64,2.89573752 5.7385099,2.6703904 5.93553265,2.48223368 C6.1325554,2.29407695 6.36852096,2.2 6.64343643,2.2 C6.92293381,2.2 7.15889938,2.29188912 7.35134021,2.4756701 C7.54378103,2.65945109 7.64,2.88698604 7.64,3.15828179 Z M8.50418455,10.3679742 L4.9,10.3679742 L4.9,9.46333016 L5.07090239,9.46333016 C5.29877339,9.46333016 5.66517736,9.43190014 5.76929083,9.36903918 C5.8734043,9.30617821 5.93724651,9.21778131 5.96081938,9.10384581 C5.98439224,8.98991031 5.99617849,8.82293838 5.99617849,8.602925 L5.99617849,7.16533772 C5.99617849,6.92175149 5.98144567,6.74888642 5.9519796,6.64673736 C5.92251352,6.54458829 5.84590287,6.46994201 5.72214534,6.42279629 C5.59838782,6.37565056 5.29073196,6.35011368 5,6.34618487 L5,5.40320196 L7.51662048,4.89638796 L7.51662048,8.602925 C7.51662048,8.93294507 7.55787237,9.15884827 7.64037739,9.28064139 C7.7228824,9.40243451 8.14666281,9.46333016 8.50418455,9.46333016 L8.50418455,10.3679742 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info_blue.aed16fba4bb1e7c7fc83fea7f04ab695.svg";
export { ForwardRef as ReactComponent };